module.exports = __webpack_public_path__ + "static/media/logo.4ef035ef.png";